import React from 'react'
import HomeSectionOne from '../HomeSectionOne/HomeSectionOne'
import HomeSectionTwo from '../HomeSectionTwo/HomeSectionTwo'
import HomeSectionThree from '../HomeSectionThree/HomeSectionThree'
import HomeSectionFour from '../HomeSectionFour/HomeSectionFour'
import HomeSectionFive from '../HomeSectionFive/HomeSectionFive'
import HomeSectionSix from '../HomeSectionSix/HomeSectionSix'
import HomeSectionSeven from '../HomeSectionSeven/HomeSectionSeven'



const NewArrivals = () => {
    return (
        <>
            <HomeSectionOne />
            <HomeSectionTwo />
            <HomeSectionThree />
            <HomeSectionFour />
            <HomeSectionFive />
            <HomeSectionSix />
            <HomeSectionSeven />
        </>
    )
}

export default NewArrivals